import { render } from "./NewEventModal.vue?vue&type=template&id=3f2ee880&ts=true"
import script from "./NewEventModal.vue?vue&type=script&lang=ts"
export * from "./NewEventModal.vue?vue&type=script&lang=ts"

import "./NewEventModal.vue?vue&type=style&index=0&id=3f2ee880&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__